import { tannlegeforeningenApi } from './client'
import { Info } from './info.model'

export const getInfo = async () => {
  return await tannlegeforeningenApi.get(`info`).json<Info>()
}
